/**
 * Cliente API `/barrio/*` — Sprint 15 S15-01.
 *
 * Por ahora solo expone la cuenta bancaria vigente para el modal
 * "Datos para transferir" del portal vecino.
 */
import { apiFetch } from './client';

export interface CuentaBancariaBarrio {
  titular_nombre: string;
  titular_rut: string;
  banco: string;
  tipo: 'corriente' | 'vista' | 'ahorro';
  numero: string;
  correo_destino: string;
}

export function getCuentaBancariaBarrio(): Promise<CuentaBancariaBarrio> {
  return apiFetch<CuentaBancariaBarrio>('/barrio/cuenta-bancaria');
}
